import React from 'react';
import { Box } from '@mui/material';
import BackupRestoreDB from '../../componen/BackupRestoreDB';

const BackupRestoreDBPages = () => {
  return (
    <Box>
      <BackupRestoreDB />
    </Box>
  );
};

export default BackupRestoreDBPages;
